import { Wire } from './wire';

export class Neutral extends Wire {
  get type() {
    return 'Wire';
  }
}
